
import { BUSINESS_UNIT_METADATA } from '../../businessunit/model/business-unit.metadata';
import { COST_CENTRE_METADATA } from '../../costcentre/model/cost-centre.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, TemporalType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class AmmunitionStockMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('AmmunitionStock', {
      ammunitionStockId: <PropertyMetadata> {
        name: 'ammunitionStockId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      businessUnit: <PropertyMetadata> {
        name: 'businessUnit',
        type: 'BusinessUnit',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return BUSINESS_UNIT_METADATA;
        },
        byReference: true,
        unique: false
      },
      costCentre: <PropertyMetadata> {
        name: 'costCentre',
        type: 'CostCentre',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return COST_CENTRE_METADATA;
        },
        byReference: true,
        unique: false
      },
      calibre: <PropertyMetadata> {
        name: 'calibre',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      closed: <PropertyMetadata> {
        name: 'closed',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: false,
        writeable: true,
        length: 1,
        unique: false
      },
      createdBy: <PropertyMetadata> {
        name: 'createdBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      createdDate: <PropertyMetadata> {
        name: 'createdDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      currentStockAmount: <PropertyMetadata> {
        name: 'currentStockAmount',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      hasStocktake: <PropertyMetadata> {
        name: 'hasStocktake',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      make: <PropertyMetadata> {
        name: 'make',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      updatedBy: <PropertyMetadata> {
        name: 'updatedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      updatedDate: <PropertyMetadata> {
        name: 'updatedDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      weight: <PropertyMetadata> {
        name: 'weight',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.ammunitionStockId;
    return nullIfContainsNull(result);
  }
}



